import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LaunchDialogService } from '@spartacus/storefront';
import { take } from 'rxjs';

@Component({
  selector: 'gen-service-parts-search-button',
  imports: [CommonModule],
  templateUrl: './service-parts-search-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServicePartsSearchButtonComponent {

  constructor(
    protected launchDialogService: LaunchDialogService,
  ) {}

  openServicePartsSearchDialog(): void {
    const servicePartsSearchDialog = this.launchDialogService.openDialog(
      'SERVICE_PARTS_SEARCH',
      undefined,
      undefined,
      {}
    );
  
    if (servicePartsSearchDialog) {
      servicePartsSearchDialog.pipe(take(1)).subscribe();
    }
  }
}